export default __webpack_public_path__ + "static/g-04-026d1cf0f3b89cca5ee9266a02540dda.png";